import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Stop = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20.373 17.05V6.95c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-10.1c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v10.1c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h10.1c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M17.204 3H7.042c-.535 0-.98 0-1.345.03-.38.03-.736.098-1.073.27a2.75 2.75 0 0 0-1.202 1.202c-.172.337-.24.693-.27 1.073-.03.365-.03.81-.03 1.345v10.16c0 .535 0 .98.03 1.345.03.38.098.736.27 1.073A2.75 2.75 0 0 0 4.625 20.7c.337.172.693.24 1.073.27.365.03.81.03 1.345.03h10.16c.535 0 .98 0 1.345-.03.38-.03.736-.098 1.074-.27a2.75 2.75 0 0 0 1.201-1.201c.172-.338.24-.694.27-1.074.03-.365.03-.81.03-1.344V6.92c0-.535 0-.98-.03-1.345-.03-.38-.098-.736-.27-1.073A2.75 2.75 0 0 0 19.622 3.3c-.338-.172-.694-.24-1.074-.27-.364-.03-.81-.03-1.344-.03'
        fill='currentColor'
      />
    )}
  </IconBase>
);
